<template lang="pug">
.scene
  //- Barra de navegación
  van-nav-bar(:title="$t('scene.title')")
    van-icon(name="menu" slot="left" @click="openSidenav")

  .main(v-if="installations")
    //- Listado de instalaciones
    InstallationRow(
      v-for="(installation, installationKey) in installations"
      :key="installationKey"
      :installationID="installationKey"
      :installationName="installation.name"
      :scenes="installation.scenes"
      @addScene="showManageScene"
      @updateScene="showManageScene")

  van-popup.van-popup--full(
    :value="openManageScenes"
    position="right"
    :overlay="false")

    ManageScenes(
      v-if="openManageScenes"
      :installationID="installationID"
      :scene="scene"
      @close="hideManageScene")
</template>

<script>
import ManageScenes from '@/components/Scenes/ManageScenes.vue';
import InstallationRow from '@/components/Scenes/InstallationRow.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: { InstallationRow, ManageScenes },

  data() {
    return {
      scene: null,
      installationID: '',
      openManageScenes: false,
    };
  },

  computed: {
    ...mapGetters({
      getAdvancedInstallations: 'unitsModule/getAdvancedInstallations',
    }),

    /**
     * Devuelve todas las instalaciones en las que el usuario es avanzado
     *
     * @return {Array[Installation]} - Listado de instalaciones
     */
    installations() {
      return this.getAdvancedInstallations();
    },
  },

  methods: {
    ...mapActions({
      openSidenav: 'globalModule/openSidenav',
    }),

    /**
     * Muestra el modal para editar/crear una escena
     */
    showManageScene(data) {
      this.installationID = data.installationID;
      this.scene = data.scene || null;
      this.openManageScenes = true;
    },

    /**
     * Oculta el modal para editar una escena
     */
    hideManageScene() {
      this.installationID = '';
      this.scene = null;
      this.openManageScenes = false;
    },
  },
};
</script>
